import { ROUTE } from '../../../routes';
let phoneNumber = '';
export const accountDetails = async (action, _datastore, { navigate, setDatastore, asyncStorage }) => { };
export const goBack = async (action, _datastore, { goBack }) => {
    goBack();
};
export const goToPrivacy = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.PRIVACY_POLICY);
};
export const goToTerms = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.PRIVACY_POLICY, { isTerms: true });
};
export const goToLendingPartner = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.LENDING_PARTNER_PAGE_MF);
};
export const goToProductDetail = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.PRODUCT_DETAILS_PAGE_MF);
};
